import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MaximizeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"maximize"}/>
}
